import { ColoursObj, Icon, IconProps } from "@eventr/common-storybook";
import { useMemo } from "react";
import { useSectionV2Context } from "../../state/sectionProvider";
import { publicColour } from "../../v2Utils";
import { useObjectContext } from "../providers/objectProvider";
import { onSkin } from "state/themeState/skin-colour";

export const ColouredIcon = (props: IconProps) => {
  const { past } = useObjectContext();
  const { isPublic } = useSectionV2Context();

  const iconColour = useMemo(() => {
    if (past) return ColoursObj.shades.shade3;
    if (isPublic && props.iconColour) return publicColour;
    return onSkin(props.iconColour) ?? ColoursObj.core.secondary;
  }, [isPublic, past, props.iconColour]);

  const bubbleColour = useMemo(() => {
    if (past) return ColoursObj.shades.shade2;
    if (isPublic && props.bubbleColour) return publicColour;
    return onSkin(props.bubbleColour);
  }, [isPublic, past, props.bubbleColour]);
  return <Icon {...props} iconColour={iconColour} bubbleColour={bubbleColour} />;
};
